import { Component, ViewChild, Input, OnInit, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { FormsModule } from '@angular/forms';


import { AutoCompleteModule } from 'primeng/autocomplete';
import { FileUploadModule, FileUploadEvent, FileSelectEvent, FileRemoveEvent } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { TabView } from 'primeng/tabview';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { IMPORT_INDEX_LIKE_FILES } from '../../../services/account-api.constants';
import { DirectionService } from '../../../services/direction.service';
import { TranslateService } from '../../../services/translate.service';
import { IndexInsertService, UploadedFileInfo } from './index-insert.service';
import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';





// SectionItem interface for calculatedSections
interface SectionItem {
		label?: string; // SectionTitle
		code?: string;  // SectionNumber
		selectedSection?: SectionItem | null; // Assigned section (full object)
		IndexSectionRecID?: string; // For assignment mapping
		RecID?: number; // For section options (match backend)
}

// --- API Result Interfaces ---
export interface SupplierInsertError {
	ItemSectionRecID: number;
	IndexSectionRecID: number;
	ItemCodeMiun: string;
	ItemAccountKey: string;
	ItemAccountName: string;
	ItemBusiness_ID: string;
	SupplierRecID: number;
	IsExist: boolean;
}

export interface SupplierRequiresAttention {
	ItemSectionRecID: number;
	IndexSectionRecID: number;
	ItemCodeMiun: string;
	ItemAccountKey: string;
	ItemAccountName: string;
	ItemBusiness_ID: string;
	SupplierRecID: number;
	IsExist: boolean;
}

export interface DuplicatedSupplierBusinessID {
	Business_ID: string;
	count: number;
}

export interface DuplicatedSupplierName {
	CustomerName: string; // SupplierName
	count: number;
}

export interface SupplierWithoutBusinessID {
	CustomerSupplierRecID: number;
	CustomerSupplierRelRecID: number;
	SupplierRecID: number;
	customer_supplier_num: number;
	CustomerSupplierExpenseCode: string | null;
	SupplierName: string;
}

export interface ResultTable {
	RecID: number;
	ErrorNumber: number | null;
	ErrorMessage: string | null;
}

export interface Payment {
	ItemSectionRecID: number;
	IndexSectionRecID: number;
	ItemCodeMiun: string;
	ItemAccountKey: string;
	ItemAccountName: string;
	PaymentType: string;
	PaymentTypeCode: string;
	PaymentTypeRecID: number;
	CreditCardNum: string | null;
	CreditCardName: string | null;
	BankNum: string | null;
	BankBranch: string | null;
	BankName: string | null;
	BankAccountNum: string | null;
	BankRecID: number | null;
	BankCode: string | null;
	BankOfficialNameEn: string | null;
	BankOfficialNameHe: string | null;
	CreditCardTypeRecID: number | null;
	IsBankUpdated: number | null;
}

export interface CustomerMoveCodeExpense {
	CustomerMoveCodeRecID: number;
	ExpenseCode: string;
	Descr: string | null;
}

export interface DataSetResult {
	Table: 					SupplierInsertError[];
	Table1: 				SupplierRequiresAttention[];
	Table2: 				DuplicatedSupplierBusinessID[];
	Table3: 				DuplicatedSupplierName[];
	Table4: 				SupplierWithoutBusinessID[];
	Table5: 				ResultTable[];
	Payments_0: 			Payment[];
	CustomerMoveCode6111_0: CustomerMoveCodeExpense[];
}

export interface ApiResult {
	RefID: number;
	Status: string;
	Description: string | null;
	Errors: any[];
	IsSuccess: boolean;
	DateTimeStamp: string;
	DataSetResult: DataSetResult;
	UrlToExcellReport: string;
}


@Component({
   selector: 'app-index-insert',
   standalone: true,
   imports: [TabView, CommonModule, FileUploadModule, TagModule, TableModule, ToastModule, TabViewModule, AutoCompleteModule, FormsModule, MessageModule],
   templateUrl: './index-insert.component.html',
   styleUrls: ['./index-insert.component.scss'],
   providers: [
	   MessageService,
	   IndexInsertService,
	   TranslateService,
	   AjaxService
   ]
})


export class IndexInsertComponent implements OnInit 
{
	
	@Input() preloadedFileNames: string[] = [];
	@ViewChild('fileUpload') fileUpload!: any;

	activeTabIndex = 0;

	sectionOptions: SectionItem[] = [];
	calculatedSections: SectionItem[] = [];
	filteredSectionOptions: any[][] = [];
	allSectionsLoaded = false;
	uploadRefNum: number | null = null;

	max_excel_number: number = 3; // The number of the indexs we expect to get.

	apiResults: Array<{ fileName: string; status: string; details: string }> = [];
	sectionResults: Array<{ FileName: string; SectionNumber: string }> = [];
	errorMessage: string | null = null;

	uploadApiUrl: string = '';
	isUploading: boolean = false;

	// Use the organized API result structure
	apiResult: ApiResult | null = null;

	isSavingAssignments = false;
	uploadStarted = false;

	constructor(
		@Optional() public config: DynamicDialogConfig | null = null,
		public directionServ: DirectionService,
		public indexInsertService: IndexInsertService, // Now resolved by 'providers' array
		private ajax: AjaxService,
		private messageService: MessageService,
		public viewScopeService: ViewScopeService,	
		public translateServ: TranslateService
	) {
		this.indexInsertService.loadState();

		// Build the upload URL with parameters for p-fileupload to use
		const customerRecID = localStorage.getItem('selectedCustomer') ? JSON.parse(localStorage.getItem('selectedCustomer')!).id : '';
		const userId = this.viewScopeService.getCurrentOpertaingUserId().toString() || '';
		// Using 'ind/upload' based on the original component's internal logic, assuming this is the correct endpoint.
		this.uploadApiUrl = `${this.ajax.getBaseOfApi()}${IMPORT_INDEX_LIKE_FILES}?userId=${userId}&customerRecID=${customerRecID}`;
	}


	ngOnInit(): void {
		let data: any = null;
		if (this.config && this.config.data) {
			data = this.config.data;
			if (Array.isArray(data?.preloadedFileNames)) {
				this.preloadedFileNames = data.preloadedFileNames;
			}
			if (typeof data?.importId !== 'undefined') {
				this.uploadRefNum = data.importId;
			}
		}

		// --- PARTICIPIAL LOGIC START ---
		if (this.uploadRefNum && this.preloadedFileNames.length > 0) {
			// 1. Create dummy File objects using matching index for sizes
			const mockFiles = this.preloadedFileNames.map((name, index) => {
				const file = new File([""], name, { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

				// Get the matching size from the fileSize array passed in data
				const sizeValue = (data?.fileSize && data.fileSize[index]) ? data.fileSize[index] : 0;

				// 2. OVERRIDE THE READ-ONLY SIZE PROPERTY
				// This "tricks" the PrimeNG table into showing your historical size
				Object.defineProperty(file, 'size', {
					value: sizeValue,
					writable: false,
					configurable: true
				});

				return file;
			});

			// 3. Clear service and add these files
			this.indexInsertService.clearFiles();
			this.indexInsertService.addFiles(mockFiles);

			// 4. Force the status to 'Uploaded'
			this.uploadedFileInfo.forEach(info => {
				info.status = 'Uploaded';
				info.disp_status = 'Uploaded';
			});

			// 5. Trigger the UI flow
			this.uploadStarted = true;
			this.activeTabIndex = 1; // Jump to Sections tab
			this.loadSectionsData();
		}
		// --- PARTICIPIAL LOGIC END ---
	}

	get timelineStep(): number {
		return this.indexInsertService.timelineStep;
	}
	set timelineStep(val: number) {
		this.indexInsertService.timelineStep = val;
	}


	get uploadedFileInfo(): UploadedFileInfo[] {
		return this.indexInsertService.uploadedFileInfo;
	}


	get stepTables() {
		return this.indexInsertService.stepTables;
	}

	get saveMessage() {
		return this.indexInsertService.saveMessage;
	}

	// Track if all assignments are filled
	get allSectionsAssigned(): boolean {
		return this.calculatedSections.length > 0 && this.calculatedSections.every(row => !!row.selectedSection);
	}

	loadSectionsData() {
		this.allSectionsLoaded = true;
		this.indexInsertService.getSectionOptions().subscribe((options: any) => {
			this.sectionOptions = (options as any[]).map(option => ({
				label: option.SectionName,
				code: option.SectionCode,
				RecID: option.RecID, // match backend
				...option
			}));
			this.filteredSectionOptions = this.calculatedSections.map(() => [...this.sectionOptions]);
		});
		this.indexInsertService.getCalculatedSections(this.uploadRefNum!).subscribe((sections: any) => {
			this.calculatedSections = (sections as any[]).map(section => ({
				label: section.SectionTitle,
				code: section.SectionNumber,
				IndexSectionRecID: section.IndexSectionRecID,
				selectedSection: null
			}));
			this.filteredSectionOptions = this.calculatedSections.map(() => [...this.sectionOptions]);
		});
	}
	// Handler for Send button
	onSendAssignments() {
		// selectedSection is now the full object
		const assignments = this.calculatedSections.map(row => ({
			IndexSectionRecID: row.IndexSectionRecID,
			selectedSection: row.selectedSection || null
		}));
		this.isSavingAssignments = true;
		this.apiResult = null;
		this.indexInsertService.putSectionDefinitors(this.uploadRefNum!, assignments).subscribe({
			next: (result) => {
				this.apiResult = result as ApiResult;
				console.log('API Result:', result);
				this.isSavingAssignments = false;
				this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Assignments saved successfully.' });
			},
			error: (err) => {
				this.isSavingAssignments = false;
				this.apiResult = null;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save assignments.' });
				console.error('Save assignments error:', err);
			}
		});
		
	}

	filterSectionOptions(event: any, rowIndex: number) {
		const query = event.query.toLowerCase();
		this.filteredSectionOptions[rowIndex] = this.sectionOptions.filter(option =>
			(option.label?.toLowerCase().includes(query) || option.code?.toLowerCase().includes(query))
		);
	}

	

	onBeforeUpload() {
		this.uploadStarted = true;
	}
	get allFilesPending(): boolean {
		return this.uploadStarted && this.uploadedFileInfo.length > 0 && this.uploadedFileInfo.every(f => f.status === 'Pending');
	}

	getStatusSeverity(status: string): string {
		switch (status) {
			case 'Pending':
				return 'info';
			case 'Uploading':
				return 'warning';
			case 'Uploaded':
				return 'success';
			case 'Failed':
			case 'Error': // Added Error for robustness
				return 'danger';
			default:
				return 'secondary';
		}
	}

	onFilesSelected(event: FileSelectEvent) {
		const filesArray: File[] = Array.from(event.files);
		// Only allow up to 3 .xlsx files
		const validFiles = filesArray.filter(f => f.name.toLowerCase().endsWith('.xlsx'));
		if (validFiles.length === 0) {
			this.indexInsertService.clearFiles();
			return;
		}
		if (validFiles.length > this.max_excel_number) {
			this.indexInsertService.clearFiles();
			this.errorMessage = 'You can only upload up to 3 .xlsx files.';
			// Remove files from the file input as well
			if (this.fileUpload && this.fileUpload.clear) {
				this.fileUpload.clear();
			}
			setTimeout(() => {
				this.errorMessage = null;
			}, 4000);
			return;
		}
		this.indexInsertService.addFiles(validFiles);
		this.errorMessage = null;
	}

	showError(msg: string) {
		this.errorMessage = msg;
		setTimeout(() => {
			this.errorMessage = null;
		}, 4000);
	}

	/**
	 * This method is triggered by p-fileupload *after* a successful upload 
	 * to the [url] configured in the HTML. 
	 * We use it only to update the UI status in our local state.
	 */

	onUpload(event: FileUploadEvent) {
		this.uploadStarted = true;
		const uploadedFilesArray: File[] = Array.from(event.files);

		// Store RefNum from API response if present and originalEvent is HttpResponse
		if (
			event.originalEvent &&
			event.originalEvent instanceof HttpResponse &&
			event.originalEvent.body &&
			event.originalEvent.body.RefNum
		) {
			this.uploadRefNum = event.originalEvent.body.RefNum;
		} else {
			this.uploadRefNum = null;
		}

		// Reset uploading flag
		this.isUploading = false;

		// Update file status in local state
		uploadedFilesArray.forEach(uploadedFile => {
			const index = this.uploadedFileInfo.findIndex(item =>
				item.file.name === uploadedFile.name &&
				item.file.size === uploadedFile.size
			);
			if (index !== -1) {
				this.uploadedFileInfo[index].status = "Uploaded";
				this.uploadedFileInfo[index].disp_status = "Uploaded";
				this.messageService.add({ severity: 'success', summary: 'Uploaded', detail: `${uploadedFile.name} processed.` });
			}
		});
	}

	onError(event: any) {
		// Handle error: triggered by p-fileupload when its internal upload fails
		this.isUploading = false;
		const errorFilesArray: File[] = Array.from(event.files || []);

		errorFilesArray.forEach((file: File) => {
			const index = this.uploadedFileInfo.findIndex(item => item.file.name === file.name && item.file.size === file.size);
			if (index !== -1) {
				this.uploadedFileInfo[index].status = 'Failed';
				this.uploadedFileInfo[index].disp_status = 'Failed';
				this.messageService.add({ severity: 'error', summary: 'Upload Failed', detail: `Failed to upload ${file.name}.` });
			}
		});

		if (errorFilesArray.length === 0) {
			this.messageService.add({ severity: 'error', summary: 'Upload Failed', detail: 'Network or server error during file upload.' });
		}
		console.error('Upload error:', event);
	}

	onFileRemoved(event: FileRemoveEvent) {
		const removedFile = event.file;
		this.indexInsertService.removeFile(removedFile);
	}

	// For table and save message steps
	setStepTable(stepIdx: number, data: any[]) {
		this.indexInsertService.setStepTable(stepIdx, data);
	}
	setSaveMessage(msg: string) {
		this.indexInsertService.setSaveMessage(msg);
	}

	// --- Tab State & Icon Logic ---
	get infoTabState() {
		if (this.allFilesPending) return 'working';
		if (this.uploadedFileInfo.length === 0) return 'default';
		if (this.uploadedFileInfo.length > 0 && this.uploadedFileInfo.every(f => f.status === 'Uploaded')) return 'done';
		return 'blocked';
	}


	public downloadExcelOfResults()
	{
		if (!this.apiResult || !this.apiResult.UrlToExcellReport) {
			this.messageService.add({
				severity: 'error',
				summary: 'Error',
				detail: 'No Excel report available to download.'
			});
			return;
		}

		// Open the URL in a new tab to trigger download
		const url = this.apiResult.UrlToExcellReport;

		// Create a temporary link and trigger click
		const link = document.createElement('a');
		link.href  = url;
		link.target = '_blank';
		// Optionally set download attribute for better UX
		link.download = 'results.xlsx';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	ngDoCheck() {
		// Only auto-load if we have a RefNum and haven't loaded yet
		if (this.uploadRefNum && !this.allSectionsLoaded && this.uploadedFileInfo.every(f => f.status === 'Uploaded')) {
			this.loadSectionsData();
		}

		// Auto-advance tabs logic remains the same
		if (this.infoTabState === 'done' && this.activeTabIndex === 0) {
			this.activeTabIndex = 1;
		}

		// If all files are uploaded and we haven't loaded sections yet
		if (!this.allSectionsLoaded && this.uploadedFileInfo.length > 0 && this.uploadedFileInfo.every(f => f.status === 'Uploaded')) {
			this.loadSectionsData();
		}
		// Auto-advance to Sections tab when Info is done
		if (this.infoTabState === 'done' && this.activeTabIndex === 0) {
			this.activeTabIndex = 1;
		}
		// Auto-advance to Finish tab when Sections is done
		if (this.sectionsTabState === 'done' && this.activeTabIndex === 1) {
			this.activeTabIndex = 2;
		}
	}

	get sectionsTabState() {
		if (!this.allSectionsLoaded) return 'blocked';
		if (this.allSectionsLoaded && !this.apiResult && !this.errorMessage) return 'working';
		if (this.apiResult || this.errorMessage) return 'done';
		return 'blocked';
	}

	get finishTabState() {
		if (!this.apiResult && !this.errorMessage) return 'blocked';
		if (this.errorMessage) return 'working';
		if (this.apiResult && !this.errorMessage) return 'done';
		return 'blocked';
	}
}